import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './LightText.module.css';

const TAGS = {
    h2: 'h2',
    paragraph: 'p',
    div: 'div',
    span: 'span',
};

const SIZE_CLASS = {
    header: styles.sizeHeader,
    main: styles.sizeMain,
    secondary: styles.sizeSecondary,
    subheader: styles.sizeSubheader,
};

const COLOR_CLASS = {
    primary: styles.colorPrimary,
    secondary: styles.colorSecondary,
    error: styles.colorError,
    white: styles.colorWhite,
    white_base: styles.colorWhiteBase,
};

export const LightText = (props) => {
    const {
        variant = 'span',
        color = 'primary',
        size = 'main',
        smallCaps,
        nowrap,
        ellipsis,
        dataTestId,
        children,
        dangerouslySetInnerHTML,
        className,
        ...domProps
    } = props;

    const Tag = TAGS[variant] ?? 'span';

    const rootClass = clsx(
        styles.text,
        SIZE_CLASS[size],
        COLOR_CLASS[color],
        smallCaps && styles.smallCaps,
        nowrap && styles.nowrap,
        ellipsis && styles.ellipsis,
        className,
    );

    return (
        <Tag {...domProps} className={rootClass} data-testid={dataTestId} dangerouslySetInnerHTML={dangerouslySetInnerHTML}>
            {children}
        </Tag>
    );
};

LightText.propTypes = {
    variant: PropTypes.oneOf(['h2', 'paragraph', 'div', 'span']),
    color: PropTypes.oneOf(['primary', 'secondary', 'error', 'white', 'white_base']),
    size: PropTypes.oneOf(['header', 'main', 'secondary', 'subheader']),
    smallCaps: PropTypes.bool,
    nowrap: PropTypes.bool,
    ellipsis: PropTypes.bool,
    children: PropTypes.node,
    dangerouslySetInnerHTML: PropTypes.shape({
        __html: PropTypes.string,
    }),
    dataTestId: PropTypes.string,
};
